import gql from 'graphql-tag'

export const GET_SERVICE_ORDERS = gql`
  query ServiceOrders($filter: GetServiceOrdersFilter) {
    serviceOrders(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceOrders {
        data {
          serviceOrderId
          companyId
          code
          status
          vehicleId
          locationType
          geofenceId
          address
          picId
          startTime
          estimatedEndTime
          actualEndTime
          otherFee
          discount
          tax
          memo
          isActive
          vehicle {
            id
            licensePlate
            vehicleTypeId
            vehicleType {
              type
              vehicleTypeId
            }
          }
          geofence {
            fenceName
            geofenceId
            isServiceLoc
            serviceLocType
          }
          pic {
            fullname
          }
          price
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_SERVICE_ORDER = gql`
  query ServiceOrder($filter: GetServiceOrderFilter!) {
    serviceOrder(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceOrder {
        serviceOrderId
        companyId
        code
        status
        mechanicName
        maintenanceType
        vehicleId
        locationType
        geofenceId
        address
        odometer
        hourmeter
        refrigerator
        aggregate {
          totalLabours
          totalLabourPrice
          totalParts
          totalPartPrice
          totalServices
        }
        picId
        startTime
        estimatedEndTime
        actualEndTime
        otherFee
        discount
        tax
        memo
        isActive
        vehicle {
          id
          licensePlate
          vehicleTypeId
          odometer
          hourmeter
          refrigerator
          vehicleType {
            type
            vehicleTypeId
            category
            model
          }
        }
        vehicleId
        geofence {
          address
          fenceName
          geofenceId
          isServiceLoc
          serviceLocType
        }
        pic {
          userId
          fullname
        }
        price
      }
    }
  }
`

export const CREATE_SERVICE_ORDER = gql`
  mutation CreateServiceOrder($input: CreateServiceOrderInput!) {
    createServiceOrder(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createServiceOrder {
        serviceOrderId
        code
        status
      }
    }
  }
`

export const UPDATE_SERVICE_ORDER = gql`
  mutation UpdateServiceOrder($input: UpdateServiceOrderInput!) {
    updateServiceOrder(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateServiceOrder {
        serviceOrderId
      }
    }
  }
`

export const UPDATE_SERVICE_ORDER_STATUS = gql`
  mutation UpdateServiceOrderStatus($input: UpdateServiceOrderStatusInput!) {
    updateServiceOrderStatus(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateServiceOrderStatus {
        serviceOrderId
        companyId
      }
    }
  }
`

export const DELETE_SERVICE_ORDER = gql`
  mutation DeleteServiceOrder($input: DeleteServiceOrderInput!) {
    deleteServiceOrder(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`

export const CREATE_SERVICE_ORDER_DOC = gql`
  mutation CreateServiceOrderDoc($input: CreateServiceOrderDocInput!) {
    createServiceOrderDoc(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createServiceOrderDoc {
        serviceOrderId
        uploaderId
        fileName
        uploadAt
        url
        format
        mimeType
      }
    }
  }
`

export const GET_SERVICE_ORDER_DOCS = gql`
  query ServiceOrderDocs($filter: GetServiceOrderDocsFilter) {
    serviceOrderDocs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceOrderDocs {
        serviceOrderId
        uploaderId
        fileName
        uploadAt
        url
        format
        mimeType
      }
    }
  }
`

export const DELETE_SERVICE_ORDER_DOC = gql`
  mutation DeleteServiceOrderDoc($input: DeleteServiceOrderDocInput!) {
    deleteServiceOrderDoc(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteServiceOrderDoc {
        serviceOrderId
        uploaderId
        fileName
        uploadAt
        url
        format
        mimeType
      }
    }
  }
`
